import { apiClient } from '../../../lib/apiClient';
import type { SrmData } from '../types';

interface UserByEmailAddressResponse {
  data: {
    userByEmailAddress: {
      emailAddress: string;
      account: {
        name: string;
        srm: {
          firstName: string;
          lastName: string;
          phoneNumber?: string;
          emailAddress: string;
          team?: string;
        } | null;
      };
    } | null;
  };
}

const GET_USER_BY_EMAIL_ADDRESS_QUERY = `
  query GetUserByEmailAddress($emailAddress: String!) {
    userByEmailAddress(emailAddress: $emailAddress) {
      emailAddress
      account {
        name
        srm {
          firstName
          lastName
          phoneNumber
          emailAddress
          team
        }
      }
    }
  }
`;

/**
 * Fetches SRM data using GraphQL query
 * @param emailAddress - Email address to fetch SRM data for
 * @returns SrmData object or null if not found
 */
export const fetchSrmByEmailAddressGraphQL = async (emailAddress: string): Promise<SrmData | null> => {
  const response = await apiClient()
    .post('api/public/graphql', {
      json: {
        query: GET_USER_BY_EMAIL_ADDRESS_QUERY,
        variables: { emailAddress },
      },
    })
    .json<UserByEmailAddressResponse>();

  const user = response.data?.userByEmailAddress;
  const srm = user?.account?.srm;

  if (!srm) {
    return null;
  }

  return {
    firstName: srm.firstName,
    lastName: srm.lastName,
    emailAddress: srm.emailAddress,
    phoneNumber: srm.phoneNumber,
    team: srm.team,
  };
};
